import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=085efd47&"
import script from "./spacer.vue?vue&type=script&lang=js&"
export * from "./spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports